import React from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import CreateYourPassword from './CreateYourPassword';
import SsoEnabled from './SsoEnabled';
import DemoDataEnabled from './DemoDataEnabled';
import SetupAccount from './SetupAccount';

class InviteTokenLanding extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inviteToken: '',
      subdomain: '',
      password: '',
      onClick: false,
      passwordEntered: false,
    };
  }

  static propTypes = {
    status: PropTypes.object.isRequired,
    fetchInviteTokenValidation: PropTypes.func.isRequired,
    submitPasswordInviteToken: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    email: PropTypes.string,
    isSaml: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const searchQuery = qs.parse(this.props.location.search);
    const inviteToken = searchQuery.inviteToken;
    const querySub = this.props.match.params.subdomain;
    this.setState({
      inviteToken,
      subdomain: querySub,
      trialUsingDemoData: searchQuery.trialUsingDemoData,
    });
    this.props.fetchInviteTokenValidation(inviteToken, querySub);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status.isLoading() && this.props.status.hasError()) {
      window.location.href = '/';
    }
  }

  onClick = onClick => {
    this.setState({ onClick });
  };

  confirmedPassword = passwordConfirmed => {
    this.setState({ passwordEntered: passwordConfirmed });
  };

  setPassword = password => {
    this.setState({ password: password });
  };

  render() {
    let nextComponent;

    if (this.props.email.length === 0) {
      return null;
    }

    nextComponent = (
      <CreateYourPassword
        passwordConfirmed={this.confirmedPassword}
        setPassword={this.setPassword}
        email={this.props.email}
        password={this.state.password}
        submitPasswordInviteToken={this.props.submitPasswordInviteToken}
        inviteToken={this.state.inviteToken}
        subdomain={this.state.subdomain}
        isTrial={!!this.state.trialUsingDemoData}
      />
    );

    if (this.props.isSaml) {
      nextComponent = <SsoEnabled />;
    }

    if (this.state.passwordEntered === true) {
      const trialUsingDemoData = this.state.trialUsingDemoData;

      if (trialUsingDemoData) {
        if (trialUsingDemoData === 'true') {
          nextComponent = <DemoDataEnabled />;
        } else {
          nextComponent = <SetupAccount />;
        }
      }
    }

    return nextComponent;
  }
}

export default InviteTokenLanding;
